import React, {useContext} from 'react'

import {AuthContext} from 'providers/auth'

import UnAuthorizedHeader from './unauthorized'
import AuthorizedHeader from './authorized'


const Header = () => {
  const {isAuthenticated} = useContext(AuthContext)

  return isAuthenticated ? <AuthorizedHeader /> : <UnAuthorizedHeader />
}

export default Header
